import {
  type AppValorantRegion,
  EAppValorantRegions,
  type IAppRegionInfo,
} from "@core-types/region.enum";

export default class ValorantRegionHelper {
  static DEFAULT_REGION: AppValorantRegion = EAppValorantRegions.EU;

  static REGION_LABELS = {
    eu: "Europe",
    na: "North America",
    ap: "Asia Pacific",
    br: "Brazil",
    latin: "Latin America",
  };

  static DEFAULT_REGION_INFOS: IAppRegionInfo = {
    code: ValorantRegionHelper.DEFAULT_REGION,
    codeLabel: ValorantRegionHelper.DEFAULT_REGION.toUpperCase(),
    label:
      ValorantRegionHelper.REGION_LABELS[ValorantRegionHelper.DEFAULT_REGION],
  };

  static getAllInfo = (): IAppRegionInfo[] => {
    const regions: IAppRegionInfo[] = [];

    for (const regionCode in ValorantRegionHelper.REGION_LABELS) {
      regions.push({
        code: regionCode as AppValorantRegion,
        codeLabel: regionCode.toUpperCase() as AppValorantRegion,
        label:
          ValorantRegionHelper.REGION_LABELS[
            regionCode as keyof typeof ValorantRegionHelper.REGION_LABELS
          ],
      });
    }

    return regions;
  };

  static getInfoByCode = (code: AppValorantRegion) => {
    const allRegions = ValorantRegionHelper.getAllInfo();

    const infos = allRegions.find((region) => region.code === code);

    return infos ?? ValorantRegionHelper.DEFAULT_REGION_INFOS;
  };

  static convertToRegionEnum = (region: string): AppValorantRegion => {
    const regionKey = Object.keys(ValorantRegionHelper.REGION_LABELS).find(
      (key) => key.toLowerCase() === region.toLowerCase(),
    );

    return regionKey
      ? (regionKey as AppValorantRegion)
      : ValorantRegionHelper.DEFAULT_REGION;
  };
}
